module.exports = __webpack_public_path__ + "static/img/references1.2414c32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/references1.jpg
// module id = lRqL
// module chunks = 1